export const GET_DEFAULT_DATAVIEW = 'GET_DEFAULT_DATAVIEW';
export const GET_DEFAULT_DATAVIEW_SUCCESS = `${GET_DEFAULT_DATAVIEW}/SUCCESS`;
export const GET_DEFAULT_DATAVIEW_FAILURE = `${GET_DEFAULT_DATAVIEW}/FAILURE`;

export const GET_DATAVIEW_LIST = 'GET_DATAVIEW_LIST';
export const GET_DATAVIEW_LIST_SUCCESS = `${GET_DATAVIEW_LIST}/SUCCESS`;
export const GET_DATAVIEW_LIST_FAILURE = `${GET_DATAVIEW_LIST}/FAILURE`;

export const GET_FAVORITE_DATAVIEW_LIST = 'GET_FAVORITE_DATAVIEW_LIST';
export const GET_FAVORITE_DATAVIEW_LIST_SUCCESS = `${GET_FAVORITE_DATAVIEW_LIST}/SUCCESS`;
export const GET_FAVORITE_DATAVIEW_LIST_FAILURE = `${GET_FAVORITE_DATAVIEW_LIST}/FAILURE`;

export const CREATE_NEW_DATAVIEW = 'CREATE_NEW_DATAVIEW';
export const CREATE_NEW_DATAVIEW_SUCCESS = `${CREATE_NEW_DATAVIEW}/SUCCESS`;
export const CREATE_NEW_DATAVIEW_FAILURE = `${CREATE_NEW_DATAVIEW}/FAILURE`;

export const DELETE_DATAVIEW = 'DELETE_DATAVIEW';
export const DELETE_DATAVIEW_SUCCESS = `${DELETE_DATAVIEW}/SUCCESS`;
export const DELETE_DATAVIEW_FAILURE = `${DELETE_DATAVIEW}/FAILURE`;

export const LOCK_DATAVIEW = 'LOCK_DATAVIEW';
export const LOCK_DATAVIEW_SUCCESS = `${LOCK_DATAVIEW}/SUCCESS`;
export const LOCK_DATAVIEW_FAILURE = `${LOCK_DATAVIEW}/FAILURE`;

export const FAVORITE_DATAVIEW = 'FAVORITE_DATAVIEW';
export const FAVORITE_DATAVIEW_SUCCESS = `${FAVORITE_DATAVIEW}/SUCCESS`;
export const FAVORITE_DATAVIEW_FAILURE = `${FAVORITE_DATAVIEW}/FAILURE`;

export const GET_SHARE_URL_DATAVIEW = 'GET_SHARE_URL_DATAVIEW';
export const GET_SHARE_URL_DATAVIEW_SUCCESS = `${GET_SHARE_URL_DATAVIEW}/SUCCESS`;
export const GET_SHARE_URL_DATAVIEW_FAILURE = `${GET_SHARE_URL_DATAVIEW}/FAILURE`;

export const SHARE_DATAVIEW = 'SHARE_DATAVIEW';
export const SHARE_DATAVIEW_SUCCESS = `${SHARE_DATAVIEW}/SUCCESS`;
export const SHARE_DATAVIEW_FAILURE = `${SHARE_DATAVIEW}/FAILURE`;

export const CLEAR_DEFAULT_FILTERED_LIST = 'CLEAR_DEFAULT_FILTERED_LIST';

export const CLEAR_SHARED_DATA_VIEW = 'CLEAR_SHARED_DATA_VIEW';

export default {
  GET_DEFAULT_DATAVIEW,
  GET_DEFAULT_DATAVIEW_SUCCESS,
  GET_DEFAULT_DATAVIEW_FAILURE,

  GET_DATAVIEW_LIST,
  GET_DATAVIEW_LIST_SUCCESS,
  GET_DATAVIEW_LIST_FAILURE,

  GET_FAVORITE_DATAVIEW_LIST,
  GET_FAVORITE_DATAVIEW_LIST_SUCCESS,
  GET_FAVORITE_DATAVIEW_LIST_FAILURE,

  CREATE_NEW_DATAVIEW,
  CREATE_NEW_DATAVIEW_SUCCESS,
  CREATE_NEW_DATAVIEW_FAILURE,

  DELETE_DATAVIEW,
  DELETE_DATAVIEW_SUCCESS,
  DELETE_DATAVIEW_FAILURE,

  LOCK_DATAVIEW,
  LOCK_DATAVIEW_SUCCESS,
  LOCK_DATAVIEW_FAILURE,

  FAVORITE_DATAVIEW,
  FAVORITE_DATAVIEW_SUCCESS,
  FAVORITE_DATAVIEW_FAILURE,

  CLEAR_DEFAULT_FILTERED_LIST,

  CLEAR_SHARED_DATA_VIEW,

  GET_SHARE_URL_DATAVIEW,
  GET_SHARE_URL_DATAVIEW_SUCCESS,
  GET_SHARE_URL_DATAVIEW_FAILURE,

  SHARE_DATAVIEW,
  SHARE_DATAVIEW_SUCCESS,
  SHARE_DATAVIEW_FAILURE
};
